import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'
import ProfilePage from './pages/ProfilePage'
import SettingsPage from './pages/SettingsPage'
import SubscriptionPage from './pages/SubscriptionPage'
import InviteFriendsPage from './pages/InviteFriendsPage'
import ChangePasswordPage from './pages/ChangePasswordPage'
import DeleteAccountPage from './pages/DeleteAccountPage'
import LoginPage from './pages/LoginPage'
import AuthErrorPage from './pages/AuthErrorPage'
import InviteRedirectPage from './pages/InviteRedirectPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'

export function Router() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth-error" element={<AuthErrorPage />} />
      <Route path="/invite" element={<InviteRedirectPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<ProfilePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="subscription" element={<SubscriptionPage />} />
        <Route path="invite-friends" element={<InviteFriendsPage />} />
        <Route path="change-password" element={<ChangePasswordPage />} />
        <Route path="delete-account" element={<DeleteAccountPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
